// extracted by mini-css-extract-plugin
export var errorIcon = "_m8-1";
export var nameLogo = "_m8-0";